import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Typography, ConfirmationModal } from 'seagull';
import AccountantAccessLearnMoreButton from '~/components/AccountantAccessLearnMoreButton';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import styles from '../TeamPage.module.scss';
export default function AccountantAccessApprovalModal(props) {
    const { accountant, dismissModal, refresh } = props;
    const overlayContext = useOverlayContext();
    const { api, logBI } = useStoreActions();
    const { t: texts } = useLocaleKeys('pages.teamPage');
    const { t: commonTexts } = useLocaleKeys('common');
    const [rejectLoading, setRejectLoading] = useState(false);
    const [approveLoading, setApproveLoading] = useState(false);
    async function submit(isApprove) {
        isApprove ? setApproveLoading(true) : setRejectLoading(true);
        const vendorId = accountant.id();
        logBI(isApprove ? 13101 : 13102, {
            vendorId,
            companyName: accountant.companyName()
        });
        const request = isApprove ? api.accountants.approveVendor : api.accountants.rejectVendor;
        const { success } = await handlePromise(request(vendorId));
        if (!success) {
            overlayContext.showErrorToast(isApprove ? commonTexts.toasts.failedToApproveAccountantAccess() : commonTexts.toasts.failedToRejectAccountantAccess(), "acc-access-".concat(isApprove ? 'approve' : 'reject', "-failure"));
        } else {
            await refresh();
        }
        dismissModal();
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'accountant_access_approval_confirm'
            },
            secondaryButton: {
                name: 'accountant_access_approval_cancel'
            }
        },
        textAlignCenter: false,
        title: texts.accountantAccessTitle(),
        primaryButtonLabel: commonTexts.buttons.approve(),
        primaryButtonLoading: approveLoading,
        secondaryButtonLoading: rejectLoading,
        primaryButtonTestId: "approve-acc-access",
        secondaryButtonLabel: commonTexts.buttons.reject(),
        secondaryButtonTestId: "reject-acc-access",
        onCloseButtonClick: ()=>dismissModal(),
        onPrimaryButtonClick: ()=>submit(true),
        onSecondaryButtonClick: ()=>submit(false),
        content: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    className: styles.paragraph,
                    children: texts.pendingRequest({
                        companyName: accountant.companyName(),
                        invitedEmail: accountant.invitedEmail()
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    className: styles.paragraph,
                    children: texts.accountantAccessDescription({
                        companyName: accountant.companyName()
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    className: styles.paragraph,
                    children: texts.accountantAccessRemoveInfo()
                }),
                /*#__PURE__*/ _jsx(AccountantAccessLearnMoreButton, {
                    isVendor: false
                })
            ]
        })
    });
}
